<template>
  <div id="map-group" style="height: 500px;"></div>
</template>

<script>
import L from 'leaflet'
import markerIcon from 'leaflet/dist/images/marker-icon.png'
import markerShadow from 'leaflet/dist/images/marker-shadow.png'
import 'leaflet.markercluster'
import 'leaflet.markercluster/dist/MarkerCluster.css'
import 'leaflet.markercluster/dist/MarkerCluster.Default.css'


export default {
  props: ['data'],
  data() {
    return {
      map: null,
      markers: null
    }
  },
  mounted() {
    delete L.Icon.Default.prototype._getIconUrl

    L.Icon.Default.mergeOptions({
      iconUrl: markerIcon,
      shadowUrl: markerShadow
    })

    this.initMap()
  },
  watch: {
    data() {
      this.renderMap()
    }
  },
  methods: {
    renderMap() {
      if (!this.map || !this.data) return
      
      if (this.markers) {
        this.map.removeLayer(this.markers)
      }
      
      this.markers = L.markerClusterGroup()
      this.map.addLayer(this.markers)
      this.data.forEach(item => {
        const marker = L.marker(item.slice(0, 2))
        this.markers.addLayer(marker)
      })
    },
    initMap() {
      if (!this.data) {
        return
      }

      this.map = L.map('map-group').setView([24, 121], 8)
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png').addTo(this.map);

      this.markers = L.markerClusterGroup();
      this.map.addLayer(this.markers)
      this.data.forEach(item => {
        const marker = L.marker(item.slice(0, 2))
        this.markers.addLayer(marker)
      })

    },
  }
}
</script>
